import React, { useEffect, useState } from "react";
import { CSS } from "src/_utils/styles";
import { Image } from "src/AbstractElements";

const EBSSSChatContainer = ({ children, chatDataSetter, guidData, chatDataPreview }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [startedChat, setStartedChat] = useState(false);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      style={CSS({
        position: "fixed",
        right: 10,
        bottom: 20,
        zIndex: 9999999,
      })}
    >
      <button
        id={"chat-button-" + guidData?.guid}
        style={CSS({ borderRadius: 500, width: 50, height: 57.5 })}
        className="btn btn-primary d-flex align-items-center justify-content-center fixed bottom-4 right-4 w-16 h-16 bg-blue-500 rounded-full shadow-lg flex items-center justify-center text-white text-2xl hover:bg-blue-600 focus:outline-none"
        onClick={toggleChat}
      >
        💬
      </button>

      {!startedChat && chatDataPreview ? (
        (() => {
          let [msg, bg, header] = chatDataPreview.replace("SHOW_PREVIEW_" + guidData?.guid + "#", "").split("#");
          return (
            <div
              onClick={() => {
                setStartedChat(true);
                toggleChat();
              }}
              style={CSS({
                cursor: "pointer",
                position: "fixed",
                display: "flex",
                alignItems: "center",
                right: 10,
                bottom: 90,
                height: 100,
                width: 300,
                textAlign: "center",
                backgroundColor: "#FFF",
                borderRadius: 25,
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                padding: 10,
                backgroundImage: `url(${bg})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                justifyContent: "center",
              })}
            >
              <div className="d-flex flex-column align-items-center">
                {
                  <Image
                    attrImage={{
                      className: "img-fluid",
                      width: 30,
                      height: 30,
                      src: header,
                    }}
                  />
                }
                <span className="text-muted mt-2">{msg}</span>
              </div>
            </div>
          );
        })()
      ) : (
        <></>
      )}

      <div
        style={CSS({
          position: "fixed",
          display: isOpen && startedChat ? "block" : "none",
          right: 10,
          bottom: 90,
          height: "auto",
          width: 400,
          backgroundColor: "#FFF",
          borderRadius: 25,
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
          padding: 10,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default EBSSSChatContainer;
